import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FeatureFlagDirective } from "./directives/feature-flag.directive";
import { DocumentMaskDirective } from "./directives/document-mask.directive";
import { DocumentFormatPipe } from "./pipes/document-format.pipe";

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    declarations: [FeatureFlagDirective, DocumentMaskDirective, DocumentFormatPipe],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FeatureFlagDirective,
        DocumentMaskDirective,
        DocumentFormatPipe,
    ],
})
export class SharedModule {}
